// @ is an alias to /src

import loginModal from "@/components/modals/loginModal/loginModal.vue"
import signUpModal from "@/components/modals/signUpModal/signUpModal.vue"
import successModal from "@/components/modals/successModal/successModal.vue"
import HomeSlider from "@/components/HomeSlider/HomeSlider.vue"
import Burger from "@/components/Burger/Burger.vue"
import TransparentPreloader from "@/components/TransparentPreloader/TransparentPreloader.vue";
import NoteList from "@/components/NoteList/NoteList.vue";

import {mapGetters} from "vuex"
import facebookLogin from 'facebook-login-vuejs';
import api_requests from "../../store/api/api_requests";
import LandingHeader from "@/components/__new_ui_kit/LandingHeader/LandingHeader";

// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

export default {
    name: 'PublicBlogItem',
    data() {
        return {
            showLoginModal: false,
            showSuccessModal: false,
            showSignUpModal: false,
            headerFixed: false,
            showMobileMenu: false,
            closeBurgerMenu: false,
            isConnected: false,
            FB: false,
            errorAuth: false,
            successAuth: false,
            showPreloader: true,
            list: [],
            lastItem: {},
            currentNote: {},
        }
    },
    components: {
        loginModal,
        signUpModal,
        successModal,
        HomeSlider,
        Burger,
        facebookLogin,
        TransparentPreloader,
        NoteList,
        LandingHeader
    },
    computed:
        mapGetters(['toogleLogin', 'toogleSignUp', 'toogleSuccess', 'isLoggedIn']),
    methods: {
        toSignUp: function() {
            this.modalActiveSign = 'signup';
            this.$store.dispatch('changeVisionLogin');
            this.$store.dispatch('changeVisionSignUp');
        },
        toLogin: function () {
            this.modalActiveSign = 'login'
            this.$store.dispatch('changeVisionSignUp')
            this.$store.dispatch('changeVisionLogin')
        },
        toogleLoginModal() {
            this.$store.dispatch('changeVisionLogin')
        },
        logout() {
            this.$store.dispatch('logout')
        },

        toogleSuccessModal() {
            this.$store.dispatch('changeVisionSuccess')
        },
        toogleSignUpModal() {
            this.$store.dispatch('changeVisionSignUp')
        },
        onScroll(e) {
            window.scrollY > 0 ? this.headerFixed = true : this.headerFixed = false
        },
        toggleBurger: function () {
            let burgerMenu = document.getElementById('burger-menu');
            //burgerMenu.classList.toggle("close");
            this.closeBurgerMenu = !this.closeBurgerMenu;
            this.showMobileMenu = !this.showMobileMenu;
        },
        showItem(name) {
            this.$router.push({
                name: 'Blog Note',
                params: {
                    name: name
                }
            });
        },
        updatePage(payload) {
            this.showItem(payload.id);
            window.location.reload();
        },
        parseDate(date) {
            let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            let format = new Date(date);
            let dateNum = format.getDate();
            let dateMonthNum = format.getMonth();
            let dateYear = format.getFullYear();

            return months[dateMonthNum] + ' ' + dateNum + ', ' + dateYear;
        },

        hidePreloader() {
            if (this.list.length && Object.keys(this.currentNote).length) {
                setTimeout(() => {
                    this.showPreloader = false;
                }, 2000);
            }
        }
    },
    created() {
        window.addEventListener('scroll', this.onScroll);

        // TODO: Join this requests
        // For current selected
        api_requests.get_blog_note_by_name(this.$route.params.name).then(resp => {
            let response = resp.data;
            if (response.status === 'ok') {
                this.currentNote = response.item;
            }
            if (response.status === 'error') {
                this.$router.push({
                    name: 'Not Found'
                });
            }
            this.hidePreloader();
        });
        // For other list
        api_requests.get_public_blog().then(resp => {
            let response = resp.data;
            if (response.status === 'ok') {
                this.list = response.list;

                this.hidePreloader();
            }
        });

    },
}